var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-layout',{attrs:{"title":_vm.title,"showRefresh":false}},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }